import { writable } from 'svelte/store';

export interface BrpcResponse {
	frame: any;
	timestamp: number;
}

export const brpcResponse = writable<BrpcResponse | null>(null);
